import { render, staticRenderFns } from "./camp-reserve.vue?vue&type=template&id=70a7ead8&scoped=true&"
import script from "./camp-reserve.vue?vue&type=script&lang=js&"
export * from "./camp-reserve.vue?vue&type=script&lang=js&"
import style0 from "./camp-reserve.vue?vue&type=style&index=0&id=70a7ead8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7ead8",
  null
  
)

export default component.exports